<template>
    <v-dialog v-model="showDialog" max-width="90vw">
        <v-card>
            <v-card-title>
                Readings Chart: {{ station.Name }} - {{ station.StationNumber }}
            </v-card-title>
            <v-card-subtitle>
                {{ station.Address }}
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <!--<v-row>
                        <v-col>
                            <LineChart
                                :chart-options="chartOptions"
                                :chart-data="chartData"
                                chart-id="line"
                                dataset-id-key="label"
                                :width="500"
                                :height="500"
                            />
                        </v-col>
                    </v-row>-->
                    <v-row v-if="station && Array.isArray(station.products)">
                        <v-col>
                            <v-card>
                                <h3 class="ma-2">Runout by product:</h3>
                                <v-row class="mx-2">
                                    <v-col
                                        v-for="product in station.products"
                                        :key="product.product_id"
                                    >
                                        <v-card>
                                            <v-card-title>
                                                {{
                                                    getProductName(
                                                        product.product_id
                                                    )
                                                }}
                                            </v-card-title>
                                            <v-card-subtitle>
                                                <v-icon
                                                    v-for="tank in product.tanks"
                                                    :key="tank.Tank"
                                                    :color="
                                                        getTankColor(tank.Tank)
                                                    "
                                                >
                                                    mdi-numeric-{{ tank.Tank }}
                                                </v-icon>
                                            </v-card-subtitle>
                                            <v-card-text>
                                                <v-list dense>
                                                    <v-list-item>
                                                        Current volume:
                                                        {{
                                                            product.total_volume
                                                        }}
                                                    </v-list-item>
                                                    <v-list-item>
                                                        Runout date: <br />
                                                        <v-chip small label>
                                                            {{
                                                                product.safe_runout_at ??
                                                                    'Runout not within the next 7 days'
                                                            }}
                                                        </v-chip>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        Runout countdown: <br />
                                                        <v-chip small label>
                                                            {{
                                                                getDateTimeCountdown(
                                                                    product.safe_runout_at
                                                                ) ??
                                                                    'Runout not within the next 7 days'
                                                            }}
                                                        </v-chip>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <h3 class="ma-2">Runout by tanks:</h3>
                                <v-row class="mx-2">
                                    <v-col
                                        v-for="tank in station.tanks"
                                        :key="tank.Tank"
                                    >
                                        <v-card>
                                            <v-card-title>
                                                Tank {{ tank.Tank }}
                                            </v-card-title>
                                            <v-card-subtitle
                                                :color="
                                                    getTankColor(tank.Tank, 0.5)
                                                "
                                            >
                                                {{
                                                    getProductName(tank.Product)
                                                }}
                                            </v-card-subtitle>
                                            <v-card-text>
                                                <v-list dense>
                                                    <v-list-item>
                                                        Current volume:
                                                        {{ tank.volume }}
                                                    </v-list-item>
                                                    <v-list-item>
                                                        Runout date: <br />
                                                        <v-chip small label>
                                                            {{
                                                                tank.safe_runout_at ??
                                                                    'Runout not within the next 7 days'
                                                            }}
                                                        </v-chip>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        Runout countdown: <br />
                                                        <v-chip small label>
                                                            {{
                                                                getDateTimeCountdown(
                                                                    tank.safe_runout_at
                                                                ) ??
                                                                    'Runout not within the next 7 days'
                                                            }}
                                                        </v-chip>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="
                                        station.products &&
                                            station.products.length > 0 &&
                                            !isLoading
                                    "
                                >
                                    <v-expansion-panels>
                                        <v-expansion-panel
                                            v-for="(product,
                                            index) in station.products"
                                            :key="index"
                                        >
                                            <v-expansion-panel-header>
                                                {{
                                                    getProductName(
                                                        product.product_id
                                                    )
                                                }}
                                                rundown
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div class="my-2">
                                                    <v-chip label color="info">
                                                        Forecasted steps:

                                                        <span
                                                            class="ml-2 font-weight-bold"
                                                        >
                                                            {{
                                                                product.rundown
                                                                    ? product
                                                                          .rundown
                                                                          .length
                                                                    : 'N/A'
                                                            }}
                                                        </span>
                                                    </v-chip>
                                                    <v-chip
                                                        label
                                                        color="success"
                                                        class="ml-2"
                                                    >
                                                        Safe fill:
                                                        <span
                                                            class="ml-2 font-weight-bold"
                                                        >
                                                            {{
                                                                product.total_safe_fill
                                                            }}
                                                        </span>
                                                    </v-chip>
                                                    <v-chip
                                                        label
                                                        color="error"
                                                        class="ml-2"
                                                    >
                                                        Safe pump:
                                                        <span
                                                            class="ml-2 font-weight-bold"
                                                        >
                                                            {{
                                                                product.total_safe_pump
                                                            }}
                                                        </span>
                                                    </v-chip>
                                                    <v-chip
                                                        label
                                                        color="white"
                                                        class="ml-2 elevation-1"
                                                    >
                                                        Current volume:
                                                        <span
                                                            class="ml-2 font-weight-bold"
                                                        >
                                                            {{
                                                                product.total_volume
                                                            }}
                                                        </span>
                                                    </v-chip>
                                                </div>
                                                <v-data-table
                                                    :headers="
                                                        productRundownHeaders
                                                    "
                                                    :items="product.rundown"
                                                    :items-per-page="-1"
                                                    fixed-header
                                                    height="50vh"
                                                    class="elevation-1"
                                                >
                                                    <template
                                                        v-slot:item.timestamp="{
                                                            item
                                                        }"
                                                    >
                                                        {{ item.timestamp }}
                                                    </template>
                                                    <template
                                                        v-slot:item.consumption="{
                                                            item
                                                        }"
                                                    >
                                                        {{ item.consumption }}
                                                    </template>
                                                </v-data-table>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-row>
                                <v-row v-else>
                                    <v-card>
                                        <span class="text-center"
                                            >Loading rundowns</span
                                        >
                                        <v-progress-linear
                                            indeterminate
                                        ></v-progress-linear
                                    ></v-card>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn color="primary" @click="downloadExcelReport">
                                Download Excel Report
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="showDialog = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Axios from 'axios';
import moment from 'moment-timezone';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
} from 'chart.js';
import * as XLSX from 'xlsx';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
);

export default {
    name: 'ReadingsChart',
    props: {
        value: Boolean,
        products: Array,
        station: Object
    },
    components: {
        LineChart: LineChartGenerator
    },
    data() {
        return {
            loading: {
                data: false,
                rundowns: true
            },
            productRundownHeaders: [
                { text: 'Forecasted date', value: 'timestamp' },
                { text: 'Forecasted volume', value: 'volume' },
                { text: 'Forecasted consumption', value: 'consumption' }
            ],
            chartData: {
                labels: [],
                datasets: []
            },
            tanks: [],
            stationProducts: [],
            groupedProducts: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: { beginAtZero: true }
                }
            },
            colors: [
                'rgba(255, 99, 132', // Red
                'rgba(255, 159, 64', // Orange
                'rgba(54, 162, 235', // Blue
                'rgba(75, 192, 192', // Green
                'rgba(153, 102, 255', // Purple
                'rgba(52, 73, 94', // Dark Blue
                'rgba(255, 182, 193', // Pink
                'rgba(255, 206, 86' // Yellow
            ]
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        isLoading() {
            if (this.loading.data || this.loading.rundowns) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        station: {
            handler() {
                if (this.station && this.station.products) {
                    console.log(this.station);
                    this.getStationProductsRundowns();
                }
            },
            immediate: true
        }
    },
    methods: {
        async getStationProductsRundowns() {
            if (!Array.isArray(this.station.products)) {
                console.error(
                    'station.products is not an array:',
                    this.station.products
                );
                return;
            }

            this.loading.rundowns = true;

            for (let stationProduct of this.station.products) {
                const stationProductID = stationProduct.product_id;
                const updatedAt = this.station.tanks[0].volume_updated_at;

                if (!updatedAt) {
                    console.warn(
                        `Tank ${tank.Tank} has no volume updated time`
                    );
                    continue;
                }

                try {
                    const response = await Axios.get(
                        `/v2/locations/stations/products/rundown/${this.station.StationID}/${stationProductID}/${updatedAt}`
                    );

                    const rundown = response.data.dates.map((date, index) => ({
                        timestamp: date,
                        volume: response.data.values[index],
                        consumption: response.data.consumption[index]
                    }));

                    this.station.products.find(
                        product => product.product_id === stationProductID
                    ).rundown = rundown;
                } catch (error) {
                    console.error(
                        `Error retrieving rundown data for station product ${stationProductID}:`,
                        error
                    );
                }
            }

            this.loading.rundowns = false;
        },
        getProductName(productID) {
            if (!this.products) return;
            console.info('Looking for product: ', productID);
            const product = this.products.find(
                product => product.ProductID === productID
            );

            return product ? product.Product : `Product ${productID} not found`;
        },
        getDateTimeCountdown(dateTime) {
            if (!dateTime) return;
            const now = moment();
            const target = moment(dateTime);
            const duration = moment.duration(target.diff(now));
            return duration.humanize();
        },
        getStationProductTanks(stationProduct) {
            return stationProduct.tanks.map(tank => tank.Tank).join(', ');
        },
        getTankColor(tank, opacity = 1) {
            return this.colors[tank - 1] + ',' + opacity + ')';
        },
        downloadExcelReport() {
            const workbook = XLSX.utils.book_new();

            this.station.products.forEach(stationProduct => {
                // Create a header row with the product name, safe fill, safe pump, and current volume
                const headers = [
                    {
                        A: 'Product Name',
                        B: this.getProductName(stationProduct.product_id)
                    },
                    { A: 'Safe Fill', B: stationProduct.total_safe_fill },
                    { A: 'Safe Pump', B: stationProduct.total_safe_pump },
                    { A: 'Current Volume', B: stationProduct.total_volume },
                    //Estimated runout datetime and countdown based on the last item in the rundown
                    {
                        A: 'Estimated Runout',
                        B:
                            stationProduct.rundown[
                                stationProduct.rundown.length - 1
                            ].timestamp
                    },
                    {
                        A: 'Runout Countdown',
                        B: this.getDateTimeCountdown(
                            stationProduct.rundown[
                                stationProduct.rundown.length - 1
                            ].timestamp
                        )
                    },
                    {
                        A: 'Estimated runout volume',
                        B:
                            stationProduct.rundown[
                                stationProduct.rundown.length - 1
                            ].volume
                    },
                    {} // Empty row for separation
                ];

                // Convert the headers to worksheet format
                const headerWorksheet = XLSX.utils.json_to_sheet(headers, {
                    header: ['A', 'B']
                });

                // Add the rundown data starting after the headers
                const rundownWorksheet = XLSX.utils.json_to_sheet(
                    stationProduct.rundown,
                    {
                        header: ['timestamp', 'volume', 'consumption']
                    }
                );

                // Combine the headers and rundown data into a single worksheet
                const worksheet = XLSX.utils.sheet_add_json(
                    headerWorksheet,
                    XLSX.utils.sheet_to_json(rundownWorksheet, {
                        header: ['timestamp', 'volume', 'consumption'],
                        skipHeader: true
                    }),
                    { origin: -1 } // Append rundown data after the headers
                );

                // Set column widths to 150px (convert to 'px' equivalent in Excel's unit system)
                const columnWidths = [
                    { wpx: 150 }, // timestamp column
                    { wpx: 150 }, // volume column
                    { wpx: 150 } // consumption column
                ];
                worksheet['!cols'] = columnWidths;

                // Convert the data range into a table
                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    this.getProductName(stationProduct.product_id)
                );
            });

            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            const data = new Blob([excelBuffer], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.download = `${this.station.Name}_Forecast_Report.xlsx`;
            link.click();
        }
    }
};
</script>
